import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sd-speech-box-fill",
  "use": "sd-speech-box-fill-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"sd-speech-box-fill\"><path opacity=\".4\" d=\"M23 6h-1v11a1 1 0 01-1 1H6v1a1 1 0 001 1h11.65a1 1 0 01.624.22l3.914 3.13a.5.5 0 00.812-.39V7a1 1 0 00-1-1z\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 1a2 2 0 00-2 2v16.377a.5.5 0 00.834.372l4.023-3.62A.5.5 0 015.192 16H18a2 2 0 002-2V3a2 2 0 00-2-2H2zm13 6H5v1h10V7zm0 2H5v1h10V9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol